import { noop } from './noop.js';

var isDevelopmentEnv = process.env.NODE_ENV === 'development';
var warnedOnce = {};
var deprecationWarning = isDevelopmentEnv ? function warning(message) {
  if (!warnedOnce[message]) {
    // eslint-disable-next-line no-console
    console.warn("Warning | WEB-UI : ".concat(message));
  }
  warnedOnce[message] = true;
} : noop;

export { deprecationWarning };
//# sourceMappingURL=warning.js.map
